import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config/config';

export function SuperAdminDashboard() {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [animalStats, setAnimalStats] = useState([]);
  const [allUniqueAnimals, setAllUniqueAnimals] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const checkSuperAdminStatus = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/api/auth/check-super-admin`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        if (!data.isSuperAdmin) { navigate('/'); return; }
        setIsSuperAdmin(true);
      } catch (error) {
        navigate('/');
      }
    };
    checkSuperAdminStatus();
  }, [navigate]);

  useEffect(() => {
    const fetchAllData = async () => {
      const headers = { 'Authorization': `Bearer ${localStorage.getItem('token')}` };

      try {
        // 1. Summary Stats
        const resStats = await fetch(`${config.baseUrl}/api/dashboard/animal-stats`, { headers });
        setAnimalStats(await resStats.json());


        // 2. All Unique Animals Data
        const resAnimals = await fetch(`${config.baseUrl}/api/dashboard/unique-animals_day1`, { headers });
        const data = await resAnimals.json();
        setAllUniqueAnimals(data);
        console.log(data);

      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };

    if (isSuperAdmin) fetchAllData();
  }, [isSuperAdmin]);

  // Helper function: Data ko filter karne ke liye
  const getAnimalsByDay = (dayNumber) => {
    return allUniqueAnimals.filter(animal => parseInt(animal.slaughtering_day) === dayNumber);
  };

  // Reusable Table Component with Navigation
  const AnimalTable = ({ title, data }) => (
    <div className="bg-indigo-50/50 p-6 rounded-lg shadow-md mb-6 border-l-4 border-indigo-800">
      <h2 className="text-xl font-bold mb-4 text-indigo-900 flex items-center">
        {title}
        <span className="ml-auto bg-indigo-200 text-indigo-800 px-3 py-1 rounded-full text-sm">
          Total: {data.length}
        </span>
      </h2>
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto">
          <thead className="bg-indigo-800 text-white">
            <tr className="text-xs uppercase tracking-wider">
              <th className="px-6 py-3">Type</th>
              <th className="px-6 py-3">Category</th>
              <th className="px-6 py-3">Animal No</th>
              <th className="px-6 py-3">Remaining Shares</th>
              <th className="px-6 py-3">Action</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200 text-center">
            {data.map((animal, index) => (
              <tr key={index} className="hover:bg-indigo-50 transition-colors">

                <td className="px-6 py-4 capitalize font-semibold">{animal.animal_type}</td>
                <td className="px-6 py-4 text-sm">{animal.category}</td>
                <td className="px-6 py-4 font-black text-indigo-700">{animal.animal_number}</td>
                <td className="px-6 py-4">
                  <span className={`px-2 py-1 rounded-full text-xs font-bold ${animal.available_shares === 0 ? 'bg-red-100 text-red-600' : 'bg-green-100 text-green-600'}`}>
                    {animal.available_shares} Shares Left
                  </span>
                </td>
                <td className="px-6 py-4">
                  <button
                    onClick={() => navigate(`/manual-booking/${animal.animal_number}`, { state: { id: animal.animal_number, available: animal.available_shares } })}
                    className="..."
                  >
                    Book Now
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  if (!isSuperAdmin) return <div className="flex justify-center items-center h-screen font-black text-indigo-900">VERIFYING ADMIN...</div>;

  return (
    <main className="min-h-screen p-2">
      <div className="max-w-7xl mx-auto">


        {/* TOP SUMMARY SECTION */}
        <section className="bg-indigo-100/50   p-6 rounded-md shadow-xl border border-indigo-50 mb-6">
          <h2 className="text-2xl text-indigo-900 font-black mb-6 uppercase tracking-tighter text-center italic">Booking Overview</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full ">
              <thead className="bg-indigo-800 font-black text-white">
                <tr className="text-center font-bold uppercase text-[11px] tracking-widest ">
                  <th className="px-6 py-2">Animal</th>
                  <th className="px-6 py-2">Category</th>
                  <th className="px-6 py-2">Day 1</th>
                  <th className="px-6 py-2">Day 2</th>
                  <th className="px-6 py-2">Day 3</th>
                  <th className="px-6 py-2 bg-indigo-900">Total</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-300 text-center font-bold text-slate-600">
                {animalStats.map((stat, index) => (
                  <tr key={index} className="hover:bg-slate-50">
                    <td className="px-6 py-3 capitalize">{stat.animal_type}</td>
                    <td className="px-6 py-3 text-sm font-normal">{stat.category}</td>
                    <td className="px-6 py-3 text-sm text-indigo-600">{stat.day1 || 0}</td>
                    <td className="px-6 py-3 text-sm text-indigo-600">{stat.day2 || 0}</td>
                    <td className="px-6 py-3 text-sm text-indigo-600">{stat.day3 || 0}</td>
                    <td className="px-6 py-3 text-sm bg-indigo-800 text-indigo-100 font-black">{stat.total_animals || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* DYNAMIC DAY-WISE TABLES */}
        <div className="space-y-12 mb-20">
          <AnimalTable title="Day 01 Slaughtering" data={getAnimalsByDay(1)} />
          <AnimalTable title="Day 02 Slaughtering" data={getAnimalsByDay(2)} />
          <AnimalTable title="Day 03 Slaughtering" data={getAnimalsByDay(3)} />
        </div>

      </div>
    </main>
  );
}